import Box from '@cloudscape-design/components/box'
import Container from '@cloudscape-design/components/container'
import Header from '@cloudscape-design/components/header'
import Link from '@cloudscape-design/components/link'
import SpaceBetween from '@cloudscape-design/components/space-between'

export default function DataDeletionPage() {
  return (
    <Box padding="xxl">
      <Container>
        <SpaceBetween size="l">
          <Header
            variant="h1"
            description="How to request deletion of your data from Sabar"
          >
            Data Deletion Instructions
          </Header>

          <SpaceBetween size="m">
            <Header variant="h2">What data we store</Header>
            <Box variant="p">
              When you use Sabar, we store your account profile, content you have created, and
              tokens needed to connect to the third-party platforms you authorize (including
              Facebook, Google, and others). If you connected your Facebook account, we may store
              your Facebook user ID, profile name, and the access tokens required to post on your
              behalf.
            </Box>
          </SpaceBetween>

          <SpaceBetween size="m">
            <Header variant="h2">Deleting connected-platform data only</Header>
            <Box variant="p">
              If you want to remove only a specific third-party connection (for example, revoke
              Facebook access) without deleting your Sabar account, open the Settings page inside
              the app and click "Disconnect" next to the platform. We will delete the associated
              tokens and platform identifiers within 7 days. You can also revoke access at any
              time from the third-party's own app settings — for Facebook, at{' '}
              <Link
                href="https://www.facebook.com/settings?tab=business_tools"
                external
              >
                facebook.com/settings → Business Integrations
              </Link>
              .
            </Box>
          </SpaceBetween>

          <SpaceBetween size="m">
            <Header variant="h2">Deleting your entire Sabar account</Header>
            <Box variant="p">
              To request full deletion of your Sabar account and all associated data, email us at{' '}
              <Link href="mailto:privacy@sabar.ai?subject=Account%20Deletion%20Request">
                privacy@sabar.ai
              </Link>{' '}
              from the email address on your account with the subject "Account Deletion Request".
              We will confirm and complete the deletion within 30 days and send you confirmation
              when it is done.
            </Box>
          </SpaceBetween>

          <SpaceBetween size="m">
            <Header variant="h2">What gets deleted</Header>
            <Box variant="p">
              Upon account deletion we remove your profile, content, platform connection tokens,
              and associated analytics. Some records may be retained in backups for a limited
              period and in logs where required for security, fraud prevention, or legal
              compliance. Those copies are not used for any other purpose and are purged on the
              normal backup rotation schedule.
            </Box>
          </SpaceBetween>

          <SpaceBetween size="m">
            <Header variant="h2">Questions</Header>
            <Box variant="p">
              Contact{' '}
              <Link href="mailto:privacy@sabar.ai">privacy@sabar.ai</Link> for any questions about
              this process.
            </Box>
          </SpaceBetween>
        </SpaceBetween>
      </Container>
    </Box>
  )
}
